import React, { Component } from "react";
import { TweenMax, Back } from "gsap";

class AudioNotice extends Component {
	constructor(props) {
		super(props);
        this.callBackMade = false;
		this.state = {
            selectedOption: '',
            selectionMade: false,
            gameReady: false,
            killSelf: false
		}
    }

    handleOptionChange (changeEvent) {
        this.setState({
            selectedOption: changeEvent.target.value.toString(),
            selectionMade: true
        });
        TweenMax.delayedCall(0.2, () => this.isTimeToGo())
    }

    isTimeToGo () {
        if (this.state.gameReady) {
            if ((this.state.selectionMade) && (this.callBackMade === false)) {
                this.props.callback(this.state.selectedOption)
                this.callBackMade = true;
                TweenMax.to('.audio-notice', 0.5, {scale: 0, autoAlpha: 0, ease:Back.easeOut, delay: 0.5, onComplete: this.cleanUp() })
            }
        } 
    }

    cleanUp () {
        TweenMax.killAll(true, true, true, true);
    }
    
	componentDidMount() {
        // initialize art
        TweenMax.set('#speedlines, .radio1, .radio2, .turnOnAudio', {autoAlpha: 0});
        TweenMax.set(['#headphones'], {scale: 0, transformOrigin: 'center center'})
        TweenMax.to(['#headphones'], 0.65, {scale: 1, ease: Back.easeOut, transformOrigin: 'center center', delay: 1, onComplete: () => this.doSecondary()})
        
    }

    getRandomInt (min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	getRandomArbitrary (min, max) {
		return Math.random() * (max - min) + min;
    }
    
    doSecondary () {
        this.speedLines();
        TweenMax.to(['#headphones'], 0.175, {x: "+=3", y: "+=3", rotation: "-=3", transformOrigin: 'center center', ease: Back.easeOut, yoyo: true, repeat: -1 })
    }

    speedLines () {
        const speedlines = this.refs.speedlines.childNodes;
		speedlines.forEach(line => {
			TweenMax.set(line, {
				scaleX: 0,
				scaleY: 0,
				autoAlpha: 0,
				transformOrigin: "50% 50%"
            });
            TweenMax.to(line, this.getRandomArbitrary(0.1, 0.3), {
				scaleX: 1,
				scaleY: 1,
                autoAlpha: 1,
                ease: Back.easeOut,
				delay: 0.175, 
                transformOrigin: "50% 50%",
                onComplete: () => {
                    TweenMax.to(line, 0.175, {
                        ease: Back.easeOut,
                        transformOrigin: "50% 50%",
                        x: "+=3",
                        y: "+=3",
                        yoyo: true,
                        repeat: -1
                    })
                }
            });
            TweenMax.to(['.radio1, .radio2, .turnOnAudio'], 1, { autoAlpha: 1})
        })
        TweenMax.set('#speedlines', {autoAlpha: 1});
    }
    
    componentWillReceiveProps (nextProps) {
        if (nextProps.startScreenReady) {
            this.setState({
                gameReady: true
            });
            TweenMax.delayedCall(0.2, () => this.isTimeToGo())
        }
    }

	componentWillUnmount() {
	}

	render() {
        let barStyles = {
			width: `${this.props.successCount / this.props.imageCount * 100}%`
        };
        let loaderinfo = this.props.successCount < 1 ? 'LOADING AUDIO' : 'LOADING IMAGES';
        if (this.state.gameReady) loaderinfo = "ALL ASSETS LOADED!";
		return (
			<div className="audio-notice">
                <svg version="1.1" id="headphone-art" x="0px" y="0px" viewBox="0 0 385.607 185.404" enableBackground="new 0 0 385.607 185.404">
                    <g id="headphones">
                        <g>
                            <polygon fill="#42403D" points="247.699,56.163 252.773,85.485 238.765,78.396 235.603,54.622 		"/>
                            <polygon fill="#070401" points="252.773,85.485 244.559,87.578 242.737,86.396 234.365,81.885 232.003,80.489 238.765,78.396 		
                                "/>
                            <polygon fill="#E51130" points="244.289,128.984 238.529,130.683 235.423,118.655 238.213,109.53 247.552,109.316 
                                251.198,115.549 246.911,128.207 		"/>
                            <polygon fill="#6D6356" points="241.229,38.442 247.699,56.163 235.603,54.622 228.29,28.597 		"/>
                            <polygon fill="#FF61BB" points="244.964,108.011 247.552,109.316 238.213,109.53 232.205,104.163 241.431,106.21 		"/>
                            <polygon fill="#182433" points="244.964,108.011 241.431,106.21 242.05,96.804 242.287,96.815 		"/>
                            <polygon fill="#182433" points="244.289,128.984 239.282,141.631 224.689,140.775 215.676,120.68 230.056,89.243 233.522,90.627 
                                232.205,104.163 228.233,113.4 227.693,121.344 230.484,129.501 238.529,130.683 		"/>
                            <polygon fill="#AA0909" points="233.522,90.627 234.365,81.885 242.737,86.396 242.05,96.804 241.431,106.21 232.205,104.163 		
                                "/>
                            <polygon fill="#070401" points="239.282,141.631 224.903,145.276 211.907,145.715 224.689,140.775 		"/>
                            <polygon fill="#2E2E2E" points="235.603,54.622 238.765,78.396 232.003,80.489 230.967,55.319 225.825,37.722 224.07,31.691 
                                212.121,23.117 184.971,26.628 170.49,37.879 155.154,60.664 148.268,85.98 145.455,84.157 152.904,59.685 168.093,36.338 
                                183.711,23.961 213.527,20.158 228.29,28.597 		"/>
                            <polygon fill="#AA0909" points="235.423,118.655 238.529,130.683 230.484,129.501 227.693,121.344 		"/>
                            <polygon fill="#FF3386" points="238.213,109.53 235.423,118.655 228.233,113.4 232.205,104.163 		"/>
                            <polygon fill="#AA0909" points="235.423,118.655 227.693,121.344 228.233,113.4 		"/>
                            <polygon fill="#42403D" points="230.056,89.243 215.676,120.68 199.463,121.13 212.346,89.243 		"/>
                            <polygon fill="#070401" points="224.07,31.691 225.825,37.722 225.758,37.744 213.809,37.182 184.971,26.628 212.121,23.117 		"/>
                            <polygon fill="#2E2E2E" points="215.676,120.68 224.689,140.775 211.907,145.715 199.463,121.13 		"/>
                            <polygon fill="#070401" points="213.809,37.182 185.815,47.027 170.49,37.879 184.971,26.628 		"/>
                            <polygon fill="#070401" points="185.815,47.027 171.896,65.446 155.154,60.664 170.49,37.879 		"/>
                            <path fill="#182433" d="M152.679,107.099l-2.048,4.501l-1.08,2.374l0.743,4.354l0.54,3.15l-0.011,0.09h0.023l1.238,7.212
                                l0.281,1.643l8.022,3.24l4.501-2.959l4.354-13.637l-2.667-12.523l-11.252-3.229L152.679,107.099z M177.072,103.701
                                c0.191,0.563-0.191,24.191-0.191,24.191l-11.814,15.752l-21.558-7.876l-4.883-23.437l9.564-20.624l2.329,0.338l8.99,1.316
                                l11.747,1.721C171.255,95.083,176.881,103.139,177.072,103.701z"/>
                            <polygon fill="#182433" points="171.896,65.446 165.708,88.377 160.78,87.814 152.487,86.543 148.268,85.98 155.154,60.664 		"/>
                            <polygon fill="#070401" points="166.574,104.545 169.241,117.068 160.24,122.132 159.542,111.724 		"/>
                            <polygon fill="#070401" points="169.241,117.068 164.887,130.705 160.24,122.132 		"/>
                            <polygon fill="#070401" points="166.574,104.545 159.542,111.724 158.293,110.88 152.679,107.099 155.323,101.316 		"/>
                            <polygon fill="#070401" points="165.067,143.645 153.253,142.711 134.125,136.714 143.509,135.768 		"/>
                            <polygon fill="#070401" points="160.24,122.132 164.887,130.705 160.386,133.664 152.364,130.424 152.082,128.781 
                                152.364,128.736 		"/>
                            <polygon fill="#AA0909" points="160.78,87.814 159.52,93.294 159.508,93.361 150.518,92.045 150.518,92.033 152.487,86.543 		"/>
                            <polygon fill="#2E2E2E" points="154.963,120.759 155.885,120.579 156.583,113.412 158.293,110.88 159.542,111.724 160.24,122.132 
                                152.364,128.736 152.082,128.781 150.845,121.569 151.88,121.366 152.87,121.175 153.883,120.973 		"/>
                            <polygon fill="#2E2E2E" points="153.084,112.354 152.094,112.05 151.238,111.791 150.631,111.6 152.679,107.099 158.293,110.88 
                                156.583,113.412 155.672,113.13 154.828,112.883 153.883,112.59 		"/>
                            <polygon fill="#AA0909" points="156.583,113.412 155.885,120.579 154.963,120.759 155.672,113.13 		"/>
                            <polygon fill="#E51130" points="155.672,113.13 154.963,120.759 153.883,120.973 154.828,112.894 154.828,112.883 		"/>
                            <polygon fill="#AA0909" points="154.828,112.883 154.828,112.894 153.883,120.973 152.87,121.175 153.883,112.59 		"/>
                            <polygon fill="#E51130" points="153.883,112.59 152.87,121.175 151.88,121.366 151.869,121.333 153.084,112.354 		"/>
                            <polygon fill="#AA0909" points="153.084,112.354 151.869,121.333 151.88,121.366 150.845,121.569 150.833,121.479 152.094,112.05 
                                        "/>
                            <polygon fill="#E51130" points="152.094,112.05 150.833,121.479 150.293,118.328 150.327,118.328 151.238,111.791 		"/>
                            <polygon fill="#AA0909" points="151.238,111.791 150.327,118.328 150.293,118.328 149.551,113.974 150.631,111.6 		"/>
                            <polygon fill="#42403D" points="148.189,91.707 138.625,112.331 128.69,112.14 138.817,93.575 		"/>
                            <polygon fill="#2E2E2E" points="138.625,112.331 143.509,135.768 134.125,136.714 128.69,112.14 		"/>
                        </g>
                    </g>
                    <g id="speedlines" ref="speedlines">
                        <polygon fill="#FFEA92" points="263.407,102.484 349.201,95.452 363.828,101.922 	"/>
                        <polygon fill="#FFEA92" points="257.5,123.019 335.417,135.396 348.638,129.208 	"/>
                        <polygon fill="#FFEA92" points="125.013,105.579 103.635,96.578 76.349,94.89 	"/>
                        <polygon fill="#FFEA92" points="120.793,126.394 105.322,123.581 80.006,134.833 	"/>
                        <polygon fill="#FFEA92" points="116.011,114.017 21.779,89.826 27.686,99.39 	"/>
                        <polygon fill="#FFEA92" points="262.001,86.17 289.849,57.197 283.661,47.914 	"/>
                        <path fill="#FFEA92" d="M133.451,86.732L81.975,23.161c0,0-19.69,0.844-18.565,2.25C64.535,26.817,133.451,86.732,133.451,86.732z"
                            />
                        <polygon fill="#FFEA92" points="289.567,88.42 360.171,65.635 337.949,68.167 	"/>
                        <path fill="#FFEA92" d="M251.031,137.927l12.658,10.126c0,0,17.721,1.406,16.877,0.844S251.031,137.927,251.031,137.927z"/>
                        <polygon fill="#FFEA92" points="127.263,152.273 124.169,165.494 139.359,148.617 	"/>
                    </g>
                </svg>
                {/* <h3 className="instructions-start">Instructions:</h3> */}
                <p>To ensure you get the full game experience, please do the following: </p>
                <ol>
                    <li>Turn off your ad blocker or white-list this page, then reload the page. </li>
                    <li>Use headphones while playing—this game uses tons of music and sound.</li>
                </ol>
                <h3 className="turnOnAudio">TURN ON AUDIO?</h3>
                
                <div className="radioGroup">
                    <div className="radio radio1">
                        <label>
                            <input type="radio" value="yes" checked={this.state.selectedOption === 'yes'} onChange={this.handleOptionChange.bind(this)} />
                            <span></span>Yup
                        </label>
                    </div>
                    <div className="radio radio2">
                        <label>
                            <input type="radio" value="no" checked={this.state.selectedOption === 'no'} onChange={this.handleOptionChange.bind(this)}/>                        
                            <span></span>Nope
                        </label>
                    </div>
                    
                </div>
                <div className="progress">
                    <div className="status">{loaderinfo}</div>    
                    <div className="holder">
                        <div className="bar" style={barStyles}></div>
                    </div>
                </div>
                

                
			</div>
		);
	}
}

export default AudioNotice;



// WEBPACK FOOTER //
// ./src/components/AudioNotice.js